import { EventSponsor } from "../../../Models/EventSponsor";
import { displayDateOnly } from "../../../Utils";
import { HiPencilAlt, HiXCircle } from "react-icons/hi";
import { Button } from "flowbite-react";

export default function EventSponsorsList({
  data,
  onEdit,
  onDelete,
}: {
  data: EventSponsor[];
  onEdit: (s: EventSponsor) => void;
  onDelete: (id: number) => void;
}) {
  const formatCurrency = (n: number | null | undefined) =>
    n != null
      ? new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(n)
      : "—";

  return (
    <div className="overflow-auto border rounded-lg">
      {data.length === 0 ? (
        <div className="p-8 text-center text-gray-500">
          No sponsors yet. Add one to get started.
        </div>
      ) : (
        <table className="min-w-full text-sm">
          <thead className="bg-gray-200">
            <tr>
              <th className="text-left px-4 py-2">Name</th>
              <th className="text-left px-4 py-2">Event</th>
              <th className="text-left px-4 py-2">Source</th>
              <th className="text-left px-4 py-2">Amount</th>
              <th className="text-left px-4 py-2">Date</th>
              <th className="text-left px-4 py-2">Image</th>
              <th className="text-left px-4 py-2 whitespace-nowrap">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((s) => (
              <tr key={s.id} className="border-t hover:bg-gray-50">
                <td className="px-4 py-2 font-medium">{s.name}</td>
                <td className="px-4 py-2">{s.eventName ?? "—"}</td>
                <td className="px-4 py-2">
                  {s.memberName
                    ? `Member: ${s.memberName}`
                    : s.publicCompanyName
                    ? `Company: ${s.publicCompanyName}`
                    : "Custom"}
                </td>
                <td className="px-4 py-2">{formatCurrency(s.sponsorAmount)}</td>
                <td className="px-4 py-2">
                  {s.dateCreated
                    ? displayDateOnly(new Date(s.dateCreated))
                    : "—"}
                </td>
                <td className="px-4 py-2">
                  {(() => {
                    const memberLogo =
                      s.memberLogoUrl ??
                      ((s as Record<string, unknown>).MemberLogoUrl as
                        | string
                        | null
                        | undefined);
                    const src =
                      s.sponsorImageUrl ?? (s.memberId ? memberLogo : null);
                    return src ? (
                      <img
                        src={src}
                        alt=""
                        className="h-10 w-10 object-contain rounded"
                      />
                    ) : (
                      "—"
                    );
                  })()}
                </td>
                <td className="px-4 py-2 whitespace-nowrap">
                  <Button
                    size="xs"
                    color="light"
                    className="mr-1"
                    onClick={() => onEdit(s)}
                    title="Edit"
                  >
                    <HiPencilAlt className="mr-1" />
                    Edit
                  </Button>
                  <Button
                    size="xs"
                    color="failure"
                    onClick={() => onDelete(s.id)}
                    title="Delete"
                  >
                    <HiXCircle />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
